(() => {
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => [...r.querySelectorAll(s)];
  const setHeaderState = () => {
    const header = q('.section-header');
    if (!header) return;
    const sync = () => header.classList.toggle('dnl-header-scrolled', window.scrollY > 18);
    sync();
    window.addEventListener('scroll', sync, { passive: true });
  };
  const setupVisualizer = () => {
    qa('[data-dnl-size-visualizer]').forEach((section) => {
      const artwork = q('[data-dnl-artwork]', section);
      const label = q('[data-dnl-size-label]', section);
      const buttons = qa('[data-dnl-size]', section);
      if (!artwork || !buttons.length) return;
      const apply = (button) => {
        buttons.forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
        const raw = Number(button.dataset.dnlSize || 60);
        const cm = Number.isFinite(raw) && raw > 0 ? raw : 60;
        const rawWidth = Number(button.dataset.dnlWidth || cm);
        const rawHeight = Number(button.dataset.dnlHeight || rawWidth);
        const widthCm = Number.isFinite(rawWidth) && rawWidth > 0 ? rawWidth : cm;
        const heightCm = Number.isFinite(rawHeight) && rawHeight > 0 ? rawHeight : widthCm;
        const referenceWidthPct = Number(section.dataset.dnlReferenceWidthPct || 34.5);
        const widthPct = Math.max(6, Math.min(60, referenceWidthPct * (widthCm / 100)));
        artwork.style.setProperty('--dnl-artwork-width', `${widthPct}%`);
        const hasVisual = section.dataset.dnlHasVisual === 'true';
        if (hasVisual) {
          if (!artwork.classList.contains('dnl-wall__art--circle')) {
            artwork.style.aspectRatio = `${widthCm} / ${heightCm}`;
          }
        } else {
          artwork.style.aspectRatio = '1 / 1';
          artwork.classList.remove('dnl-wall__art--circle');
        }
        if (label) label.textContent = button.dataset.dnlLabel || `${cm} cm`;
      };
      buttons.forEach((button) => button.addEventListener('click', () => apply(button)));
      apply(buttons.find((b) => b.getAttribute('aria-pressed') === 'true') || buttons[0]);
    });
  };
  const setupChooseOptionsLabels = () => {
    const label = 'Izaberi dimenziju i boju';
    const selector = 'modal-opener .quick-add__submit[data-product-url]';

    const replaceButtonLabel = (button) => {
      const textNode = [...button.childNodes].find(
        (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
      );
      if (textNode) textNode.textContent = ` ${label} `;
    };

    const apply = (root = document) => {
      if (root.nodeType === Node.ELEMENT_NODE && root.matches?.(selector)) {
        replaceButtonLabel(root);
      }
      root.querySelectorAll?.(selector).forEach(replaceButtonLabel);
    };

    apply();

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) apply(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };
  const setupDesktopProductDescription = () => {
    const productInfo = q('product-info');
    if (!productInfo) return;
    const grid = q('.product.grid', productInfo);
    const description = q('.product__description', productInfo);
    if (!grid || !description || description.dataset.dnlDesktopMoved === 'ready') return;

    const originalParent = description.parentNode;
    const placeholder = document.createComment('dnl-product-description-home');
    originalParent.insertBefore(placeholder, description);

    const page = grid.parentElement;
    const wide = document.createElement('div');
    wide.className = 'dnl-product-description-wide';
    wide.setAttribute('data-dnl-product-description-wide', '');
    grid.insertAdjacentElement('afterend', wide);

    description.dataset.dnlDesktopMoved = 'ready';

    const sync = () => {
      const desktop = window.matchMedia('(min-width: 990px)').matches;
      if (desktop) {
        if (description.parentNode !== wide) wide.appendChild(description);
        description.classList.add('dnl-product-description--wide');
      } else {
        if (description.parentNode !== originalParent) {
          originalParent.insertBefore(description, placeholder.nextSibling);
        }
        description.classList.remove('dnl-product-description--wide');
      }
    };

    sync();
    window.addEventListener('resize', sync, { passive: true });
  };
  const setupStickyATC = () => {
    const bar = q('[data-dnl-sticky-atc]');
    const productInfo = q('product-info');
    if (!bar || !productInfo) return;
    const stickyButton = q('[data-dnl-sticky-buy]', bar);
    const stickyPrice = q('[data-dnl-sticky-price]', bar);
    const mainForm = q('form[data-type="add-to-cart-form"]', productInfo) || qa('form', productInfo).find((form) => q('[name="add"]', form));
    const mainButton = mainForm ? q('[name="add"]', mainForm) : null;
    if (!stickyButton || !mainButton) return;
    document.body.classList.add('dnl-has-sticky-atc');
    const sync = () => {
      stickyButton.disabled = !!mainButton.disabled;
      stickyButton.setAttribute('aria-disabled', String(!!mainButton.disabled));
      const price = q('.price--large', productInfo);
      if (price && stickyPrice) stickyPrice.textContent = price.innerText.trim().replace(/\s+/g, ' ');
      const text = q('span:not(.sold-out-message)', mainButton);
      if (text && text.textContent.trim()) stickyButton.textContent = text.textContent.trim();
    };
    stickyButton.addEventListener('click', () => {
      sync();
      if (mainButton.disabled) {
        mainButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      mainButton.click();
    });
    const observer = new MutationObserver(() => requestAnimationFrame(sync));
    observer.observe(productInfo, { subtree: true, childList: true, characterData: true, attributes: true });
    productInfo.addEventListener('change', () => setTimeout(sync, 80));
    let mainVisible = true;
    const visibility = new IntersectionObserver((entries) => {
      mainVisible = entries[0]?.isIntersecting ?? true;
      bar.classList.toggle('is-visible', !mainVisible && window.scrollY > 320);
    }, { threshold: 0.05 });
    visibility.observe(mainButton);
    const onScroll = () => bar.classList.toggle('is-visible', !mainVisible && window.scrollY > 320);
    window.addEventListener('scroll', onScroll, { passive: true });
    sync();
  };
  const init = () => { setHeaderState(); setupVisualizer(); setupChooseOptionsLabels(); setupDesktopProductDescription(); setupStickyATC(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
